<template>
  <div>
    <create-data-form
      ref="createDataForm"
      :statusOptions="statusOptions"
      :dictType="dictType || ''"
      @ok="getList"
    />
    <a-card :bordered="false" :style="{ background: '#f2f4f5' }">
      <div class="table-operations">
        <a-button
          class="nested-add-button"
          size="small"
          @click="$refs.createDataForm.handleAdd()"
          v-hasPermi="['system:dict:add']"
        >
          <a-icon type="plus" />新增
        </a-button>
        <a-button
          class="nested-delete-button"
          :disabled="multiple"
          @click="handleDelete"
          size="small"
          v-hasPermi="['system:dict:remove']"
        >
          <a-icon type="delete" />删除
        </a-button>
      </div>
      <a-table
        :loading="loading"
        rowKey="id"
        :size="tableSize"
        :columns="columns"
        :data-source="list"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :scroll="{ y: 300 }"
        :pagination="false"
      >
        <template #bodyCell="{ column, text, record }">
          <template v-if="column.dataIndex === 'status'">
            <span>
              <dict-tag
                :options="dict.type['sys_enable_disable']"
                :value="record.status"
              />
            </span>
          </template>
          <template v-else-if="column.dataIndex === 'createTime'">
            <span>
              {{ parseTime(record.createTime) }}
            </span>
          </template>
          <template v-else-if="column.dataIndex === 'operation'">
            <div class="table-action-buttons">
              <a
                v-hasPermi="['system:dict:edit']"
                @click="$refs.createDataForm.handleUpdate(record)"
                class="edit-link"
              >
                <!-- <EditOutlined /> -->
                编辑
              </a>
              <span 
                v-hasPermi="['system:dict:remove']"
                class="action-divider"
              >|</span>
              <a
                v-hasPermi="['system:dict:remove']"
                @click="handleDelete(record)"
                class="delete-link"
              >
                <!-- <DeleteOutlined /> -->
                删除
              </a>
            </div>
          </template>
          <template v-else>
            <span>{{ text }}</span>
          </template>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import { delData, pageData } from '@/api/system/dict/data'
import CreateDataForm from './CreateDataForm'
import { EditOutlined, DeleteOutlined } from '@ant-design/icons-vue'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'DictData',
  props: {
    dictType: {
      type: String,
      required: false,
      default: '',
    },
    dictId: {
      type: String,
      required: false,
      default: '',
    },
  },
  components: {
    CreateDataForm,
    EditOutlined,
    DeleteOutlined,
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  data() {
    return {
      statusOptions: [
        { value: 1, label: '启用' },
        { value: 0, label: '禁用' },
      ],
      list: [],
      tableSize: 'small',
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        dictName: undefined,
        dictType: undefined,
        status: undefined,
      },
      columns: [
        {
          title: '字典编码',
          dataIndex: 'id',
          align: 'center',
        },
        {
          title: '字典标签',
          dataIndex: 'dictLabel',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '字典键值',
          dataIndex: 'dictValue',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '字典排序',
          dataIndex: 'dictSort',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '状态',
          dataIndex: 'status',
          align: 'center',
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          align: 'center',
        },
      ],
    }
  },
  created() {
    console.log('=== DictData created ===')
    console.log('this.dictType:', this.dictType)
    console.log('this.dictId:', this.dictId)
    console.log('=======================')
    // created 时可能 dictType 还没有传递过来，所以不在这里调用 getList
    if (this.dictType) {
      this.queryParam.dictType = this.dictType
      this.getList()
    }
  },
  computed: {},
  watch: {
    dictType: {
      immediate: true,
      handler(newVal, oldVal) {
        console.log('=== DictData watch dictType ===')
        console.log('newVal:', newVal)
        console.log('oldVal:', oldVal)
        console.log('==============================')
        if (newVal) {
          this.queryParam.dictType = newVal
          this.getList()
        }
      },
    },
  },
  methods: {
    getList() {
      // 确保 dictType 被设置到 queryParam
      this.queryParam.dictType = this.dictType
      
      // 构建参数对象，只包含有效值
      const params = {}
      if (this.queryParam.dictType) {
        params.dictType = this.queryParam.dictType
      }
      if (this.queryParam.dictName) {
        params.dictName = this.queryParam.dictName
      }
      if (this.queryParam.status !== undefined && this.queryParam.status !== null) {
        params.status = this.queryParam.status
      }
      
      console.log('=== DictData getList ===')
      console.log('this.dictType:', this.dictType)
      console.log('params:', params)
      console.log('=======================')
      
      this.loading = true
      pageData(params).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.queryParam = {
        dictName: undefined,
        dictType: undefined,
        status: undefined,
      }
      this.queryParam.dictType = this.dictType
      this.handleQuery()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const dictCodes = row.id || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中字典编码为' + dictCodes + '的数据',
        onOk() {
          return delData(dictCodes).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
            that.$store.dispatch('dict/removeDict', row.dictType)
          })
        },
        onCancel() {},
      })
    },
  },
}
</script>

<style scoped>
/* 嵌套表格按钮样式 */
.nested-add-button {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.nested-add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.nested-add-button:focus {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

.nested-delete-button {
  background-color: #F2F2F2 !important;
  border-color: #F2F2F2 !important;
  color: #333333 !important;
  border-radius: 4px !important;
}

.nested-delete-button:hover:not(:disabled) {
  background-color: #E5E5E5 !important;
  border-color: #E5E5E5 !important;
  color: #333333 !important;
}

.nested-delete-button:focus:not(:disabled) {
  background-color: #F2F2F2 !important;
  border-color: #F2F2F2 !important;
  color: #333333 !important;
}

.nested-delete-button:disabled {
  background-color: #f5f5f5 !important;
  border-color: #d9d9d9 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed !important;
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 操作列按钮样式 */
.table-action-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.table-action-buttons a {
  color: #1890ff;
  cursor: pointer;
  white-space: nowrap;
}

.table-action-buttons a:hover {
  color: #40a9ff;
}

/* 编辑按钮颜色 */
.table-action-buttons .edit-link {
  color: #165DFF !important;
}

.table-action-buttons .edit-link:hover {
  color: #4080ff !important;
}

/* 删除按钮颜色 */
.table-action-buttons .delete-link {
  color: #ff4d4f !important;
}

.table-action-buttons .delete-link:hover {
  color: #ff7875 !important;
}

.action-divider {
  margin: 0 8px;
  color: #d9d9d9;
  white-space: nowrap;
}
</style>
